/** Session intent from homepage booking bar → offert / product links. */

export const HOME_BOOKING_INTENT_KEY = 'home_booking_intent_v1';

export type HomeBookingIntent = {
  date?: string;
  event?: string;
  dateUndecided?: boolean;
};

export function saveHomeBookingIntent(intent: HomeBookingIntent): void {
  try {
    sessionStorage.setItem(HOME_BOOKING_INTENT_KEY, JSON.stringify(intent));
  } catch {
    /* ignore */
  }
}

export function readHomeBookingIntent(): HomeBookingIntent | null {
  try {
    const raw = sessionStorage.getItem(HOME_BOOKING_INTENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as HomeBookingIntent;
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function buildOffertUrl(intent: HomeBookingIntent): string {
  const params = new URLSearchParams();
  if (intent.dateUndecided) {
    params.set('dateUndecided', '1');
  } else if (intent.date) {
    params.set('date', intent.date);
  }
  if (intent.event) {
    params.set('event', intent.event);
  }
  const qs = params.toString();
  return qs ? `/offert?${qs}` : '/offert';
}

export function appendIntentToPath(path: string, intent: HomeBookingIntent | null): string {
  if (!intent) return path;
  const [base, existingQs] = path.split('?');
  const params = new URLSearchParams(existingQs || '');
  if (intent.dateUndecided) {
    params.set('dateUndecided', '1');
  } else if (intent.date) {
    params.set('date', intent.date);
  }
  if (intent.event) {
    params.set('event', intent.event);
  }
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export const HOME_BOOKING_EVENT_TYPES = [
  'Bröllop',
  'Företagsevent',
  'Fest',
  'Konferens / presentation',
  'Student',
  'Annat',
] as const;

export type HomeBookingEventType = (typeof HOME_BOOKING_EVENT_TYPES)[number];
